export const Environments = {
    PRODUCTION: 'PRODUCTION',
    STAGE: 'STAGE',
    LOCAL: 'LOCAL'
};

export const CLASSROOMS_API = {
    [Environments.PRODUCTION]: 'https://classrooms-client-api.kinedu.com/v1',
    [Environments.STAGE]: 'https://staging-classrooms-client.kinedu.com/v1',
    [Environments.LOCAL]: 'http://localhost:3003/v1'
};

export const CLASSROOMS_API_WO_VERSION = {
    [Environments.PRODUCTION]: 'https://classrooms-client-api.kinedu.com/',
    [Environments.STAGE]: 'https://staging-classrooms-client.kinedu.com/',
    [Environments.LOCAL]: 'http://localhost:3003'
};